import React, { useState } from "react";
import "./Projects.css";
import { HashLink } from "react-router-hash-link";

const Projects = () => {
  const [navDropDownBtn, setNavDropDownBtn] = useState(false);

  const handleNavDropDownBtn = () => setNavDropDownBtn(!navDropDownBtn);

  const [homeDropDownBtn, setHomeDropDownBtn] = useState(false);

  const handleHomeDropDownBtn = () => setHomeDropDownBtn(!homeDropDownBtn);

  return (
    <>
      <nav className="mobile-nav">
        <div className="mobile-nav-container">
          <div className="mobile-nav-logo-container">
            <HashLink smooth to="/#home">
              <img
                src="/assets/navlogo.png"
                alt="mobile-nav-logo"
                className="mobile-nav-logo"
              />
            </HashLink>
            <button
              className={
                navDropDownBtn
                  ? "mobile-nav-toggle active"
                  : "mobile-nav-toggle"
              }
              onClick={handleNavDropDownBtn}
            >
              <i class="fa-solid fa-bars"></i>
            </button>
          </div>
          <div
            className={
              navDropDownBtn
                ? "mobile-nav-menu-container active"
                : "mobile-nav-menu-container"
            }
          >
            <ul className="mobile-nav-menu">
              <li
                className="mobile-nav-item"
                onClick={() => setNavDropDownBtn(false)}
              >
                <HashLink smooth to="/#about-us" className="mobile-nav-link">
                  ABOUT US
                </HashLink>
              </li>
              <li
                className="mobile-nav-item"
                onClick={() => setNavDropDownBtn(false)}
              >
                <HashLink
                  smooth
                  to="/#services"
                  className="mobile-nav-link"
                  onClick={() => setHomeDropDownBtn(true)}
                >
                  SERVICES
                </HashLink>
              </li>
              <li
                className="mobile-nav-item"
                onClick={() => setNavDropDownBtn(false)}
              >
                <HashLink
                  smooth
                  to="/projects/#projects"
                  className="mobile-nav-link"
                >
                  PROJECTS
                </HashLink>
              </li>
              <li
                className="mobile-nav-item"
                onClick={() => setNavDropDownBtn(false)}
              >
                <HashLink smooth to="/#contact-us" className="mobile-nav-link">
                  CONTACT US
                </HashLink>
              </li>
            </ul>
          </div>
        </div>
      </nav>
      <nav className="navbar">
        <div className="nav-container">
          <div className="navbar__logo__container">
            <HashLink smooth to="/#home">
              <img
                src="/assets/navlogo.png"
                alt="nav-logo"
                className="navbar__logo"
              />
            </HashLink>
          </div>
          <div className="navbar__menu__container">
            <ul className="navbar__menu">
              <li className="navbar__item">
                <HashLink
                  smooth
                  to="/#about-us"
                  className="navbar__link active"
                >
                  ABOUT US
                </HashLink>
              </li>
              <li className="navbar__item">
                <HashLink
                  smooth
                  to="/#services"
                  className="navbar__link"
                  onClick={() => setHomeDropDownBtn(true)}
                >
                  SERVICES
                </HashLink>
              </li>
              <li className="navbar__item">
                <HashLink
                  smooth
                  to="/projects/#projects"
                  className="navbar__link"
                >
                  PROJECTS
                </HashLink>
              </li>
              <li className="navbar__item">
                <HashLink
                  smooth
                  to="/projects/#contact-us"
                  className="navbar__link"
                >
                  CONTACT US
                </HashLink>
              </li>
            </ul>
          </div>
        </div>
      </nav>
      <div className="projects">
        <div className="projects-home-container">
          <section className="projects__mainbg__container">
            <img
              src="/assets/mainlogo.png"
              alt="nav-logo"
              className="projects__mainbg"
            />
          </section>
          <section id="projects" className="projects-container">
            <div className="projects-title">
              <span>OUR PROJECTS</span>
            </div>
            <div className="projects-content" id="one">
              <div className="col-5">
                <p>
                  Six Units of Terrace
                  <br />
                  Duplexes and One
                  <br />
                  Fully Detached
                  <br />
                  Duplex, at Lekki
                  <br />
                  Scheme 2, Lagos
                </p>
              </div>
              <div className="col-6">
                <a href="/assets/Group 11.png" target="_blank">
                  <img src="/assets/Group 11.png" alt="1" />
                </a>
              </div>
            </div>
            <div className="projects-img">
              <div className="col-4">
                <a href="/assets/Group 1.png" target="_blank">
                  <img src="/assets/Group 1.png" alt="" />
                </a>
              </div>
              <div className="col-4">
                <a href="/assets/Group 2.png" target="_blank">
                  <img src="/assets/Group 2.png" alt="" />
                </a>
              </div>
              <div className="col-4">
                <a href="/assets/Group 3.png" target="_blank">
                  <img src="/assets/Group 3.png" alt="" />
                </a>
              </div>
            </div>
            <div className="projects-content" id="two">
              <div className="col-5">
                <p>
                  Three Units of Fully
                  <br />
                  Detached Duplexes
                  <br />
                  at Titilayo Adedoyin
                  <br />
                  Street, Omole Phase
                  <br />
                  1, Lagos
                </p>
              </div>
              <div className="col-6">
                <a href="/assets/Group 4.png" target="_blank">
                  <img src="/assets/Group 4.png" alt="1" />
                </a>
              </div>
            </div>
            <div className="projects-img">
              <div className="col-4">
                <a href="/assets/Group 8.png" target="_blank">
                  <img src="/assets/Group 8.png" alt="" />
                </a>
              </div>
              <div className="col-4">
                <a href="/assets/Group 9.png" target="_blank">
                  <img src="/assets/Group 9.png" alt="" />
                </a>
              </div>
              <div className="col-4">
                <a href="/assets/Group 16.png" target="_blank">
                  <img src="/assets/Group 16.png" alt="" />
                </a>
              </div>
            </div>
            <div className="projects-content" id="three">
              <div className="col-5">
                <p>
                  Six Units of Three
                  <br />
                  Bedroom Flats at
                  <br />
                  Abijo GRA, Lagos
                </p>
              </div>
              <div className="col-6">
                <a href="/assets/Group 12.png" target="_blank">
                  <img src="/assets/Group 12.png" alt="1" />
                </a>
              </div>
            </div>
            <div className="projects-img">
              <div className="col-4">
                <a href="/assets/Group 17.png" target="_blank">
                  <img src="/assets/Group 17.png" alt="" />
                </a>
              </div>
              <div className="col-4">
                <a href="/assets/Group 18.png" target="_blank">
                  <img src="/assets/Group 18.png" alt="" />
                </a>
              </div>
              <div className="col-4">
                <a href="/assets/Group 19.png" target="_blank">
                  <img src="/assets/Group 19.png" alt="" />
                </a>
              </div>
            </div>
            <div className="projects-content" id="four">
              <div className="col-5">
                <p>
                  Road Work at
                  <br />
                  Durumi Road,
                  <br />
                  Mpape, in Abuja.
                </p>
              </div>
              <div className="col-6">
                <a href="/assets/Group 13.png" target="_blank">
                  <img src="/assets/Group 13.png" alt="1" />
                </a>
              </div>
            </div>
            <div className="projects-img">
              <div className="col-4">
                <a href="/assets/Group 20.png" target="_blank">
                  <img src="/assets/Group 20.png" alt="" />
                </a>
              </div>
              <div className="col-4">
                <a href="/assets/Group 21.png" target="_blank">
                  <img src="/assets/Group 21.png" alt="" />
                </a>
              </div>
              <div className="col-4">
                <a href="/assets/Group 22.png" target="_blank">
                  <img src="/assets/Group 22.png" alt="" />
                </a>
              </div>
            </div>
          </section>
        </div>
      </div>
      <nav className="footer-navbar">
        <div className="nav-container">
          <div className="footer-navbar__logo__container">
            <HashLink smooth to="/#home">
              <img
                src="/assets/navlogo.png"
                alt="nav-logo"
                className="footer-navbar__logo"
              />
            </HashLink>
          </div>
          <div className="footer-navbar__menu__container">
            <ul className="footer-navbar__menu">
              <li className="footer-navbar__item">
                <HashLink
                  smooth
                  to="/#about-us"
                  className="footer-navbar__link"
                >
                  ABOUT US
                </HashLink>
              </li>
              <li className="footer-navbar__item">
                <HashLink
                  smooth
                  to="/#services"
                  className="footer-navbar__link"
                >
                  SERVICES
                </HashLink>
              </li>
              <li className="footer-navbar__item">
                <HashLink
                  smooth
                  to="/projects/#projects"
                  className="footer-navbar__link"
                >
                  PROJECTS
                </HashLink>
              </li>
            </ul>
          </div>
        </div>
      </nav>
      <footer id="contact-us" className="footer">
        <div className="footer-container">
          <div className="address">
            <p>CONTACT US</p>
            <p>
              H-215, Ikota Shopping Complex, VGC, Lekki–Epe Expressway,
              Lagos-Nigeria.
            </p>
            <p>Tel: +234 803 191 2318 | +234 805 768 3538</p>
            <p>floodweyconstruction@gmail.com</p>
          </div>
          <div className="copyright-container">
            <div className="copyright">
              <p>
                &copy;2026, FLOODWEY CONSTRUCTION COMPANY LTD. ALL RIGHTS
                RESERVED.
              </p>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Projects;
